import { DateTime } from 'luxon';

const buildTagCell = (value?: string | null): TableCell => {
  if (!value) {
    return '';
  }

  const tags = value
    .split(',')
    .map((tag) => tag.trim())
    .filter((tag) => Boolean(tag));

  if (!tags.length) {
    return '';
  }

  return {
    type: 'chip',
    data: tags.map((tag) => ({
      text: tag,
      backgroundColor: '#E1F8DC'
    }))
  };
};

const generateRows = (contacts: CoreContact[]): TableRow[] =>
  contacts.map((token) => {
    const payload: TableRow = {
      id: token.id ?? '',
      locationId: token.locationId ?? '',
      name: token.name ?? '',
      firstname: token.firstname ?? '',
      lastname: token.lastname ?? '',
      email: token.email ?? '',
      phone: token.phone ?? '',
      city: token.city ?? '',
      state: token.state ?? '',
      country: token.country ?? '',
      source: token.source ?? '',
      enquiry_type: token.enquiry_type ?? '',
      property_address: token.property_address ?? '',
      property_price: token.property_price ?? '',
      property_reference_number: token.property_reference_number ?? '',
      comments: token.comments ?? '',
      portalurl: token.portalurl ?? '',
      conversation_history: token.conversation_history ?? '',
      tags: buildTagCell(token.tags),
      createdAt: token.createdAt ? DateTime.fromISO(token.createdAt).toLocaleString(DateTime.DATETIME_MED) : '',
      updatedAt: token.updatedAt ? DateTime.fromISO(token.updatedAt).toLocaleString(DateTime.DATETIME_MED) : '',
      deletedAt: token.deletedAt ? DateTime.fromISO(token.deletedAt).toLocaleString(DateTime.DATETIME_MED) : ''
    };
    return payload;
  });

export default generateRows;
